import { writable, derived } from 'svelte/store'
import translations from './translations'

export const language = writable((navigator.language.split('-')[0] === 'fr' || navigator.languages[0].split('-')[0] === 'fr' ? 'fr' : 'en'
))
  
export const t = derived(
  language,
  ($language) => new Proxy(translations, {
    get: (target, prop) =>  {
      let translation
      if (target[prop]) {
        translation = target[prop][$language]
      }
      return translation ? translation : prop
    }
  })
);

export const toggleLanguage = () => language.update(store => {
  store === 'en' ? store = 'fr' : store = 'en'
  return store
})

export const formatI18nDate = (language, date) => new Intl.DateTimeFormat(
  language,
  {
    year: "numeric",
    month: "short",
    weekday: 'short',
    day: "2-digit"
  }
).format(new Date(date))
